import {ComponentValue, Config} from './components/types'

// Configuration object
export const config: Config = {
  Subjective: [
    {
      component: 'TextDataInput',
      name: 'Family History',
      otherProps: {
        inputType: 'text',
      },
    },
    {
      component: 'TextDataInput',
      name: 'Medical History',
      otherProps: {
        inputType: 'text',
      },
    },
    {
      component: 'TextDataInput',
      name: 'Active Medications',
      otherProps: {
        inputType: 'text',
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Stress Levels',
      otherProps: {
        values: ['Low', 'Medium', 'High'],
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Smoker',
      otherProps: {
        values: ['Yes', 'No', 'Not any more'],
      },
    },
    {
      component: 'TextDataInput',
      name: 'Number Per Day',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Vape',
      otherProps: {
        values: ['Yes - Daily', 'Yes - Occasionally', 'Not any more', 'No'],
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Cough',
      otherProps: {
        values: ['None', 'Yes, but not persistent', 'Yes, persistent'],
      },
    },
    {
      component: 'TextDataInput',
      name: 'Alcohol (units/week)',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'PlaceHolder',
      name: '',
    },
    {
      component: 'SelectDataInput',
      name: 'Energy Drinks',
      otherProps: {
        values: ['Yes - Daily', 'Yes - Occasionally', 'Not any more', 'No'],
      },
    },
    {
      component: 'TextDataInput',
      name: 'Energy Drinks Per Day',
      otherProps: {
        inputType: 'number',
        disabled: (data: ComponentValue[]) => {
          const energyDrinks = data.find(
            (item) => item.name === 'Energy Drinks',
          )?.value
          return energyDrinks !== 'Yes - Daily'
        },
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Coffee',
      otherProps: {
        values: ['Yes - Daily', 'Yes - Occasionally', 'Not any more', 'No'],
      },
    },
    {
      component: 'TextDataInput',
      name: 'Coffees Per Day',
      otherProps: {
        inputType: 'number',
        disabled: (data: ComponentValue[]) => {
          const energyDrinks = data.find(
            (item) => item.name === 'Coffee',
          )?.value
          return energyDrinks !== 'Yes - Daily'
        },
      },
    },
    {
      component: 'TextDataInput',
      name: 'Exercise (mins/week outside work)',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'TextDataInput',
      name: 'Exercise Type',
      otherProps: {
        inputType: 'text',
      },
    },
    {
      component: 'PlaceHolder',
      name: '',
    },
  ],
  Objective: [
    {
      component: 'UnitConvertibleInput',
      name: 'Height (cm)',
      otherProps: {
        measurement: 'length',
        label: 'Height',
      },
    },
    {
      component: 'UnitConvertibleInput',
      name: 'Weight (kg)',
      otherProps: {
        measurement: 'mass',
        label: 'Weight',
      },
    },
    {
      component: 'CalculatedField',
      name: 'BMI',
      otherProps: {
        calculation: (data: ComponentValue[]) => {
          const height = data.find((item) => item.name === 'Height (cm)')?.value
          const weight = data.find((item) => item.name === 'Weight (kg)')?.value
          if (!height || !weight) return undefined
          return (
            Number(weight) /
            ((Number(height) / 100) * (Number(height) / 100))
          ).toFixed(2)
        },
      },
    },
    {
      component: 'PlaceHolder',
      name: '',
    },
    {
      component: 'TextDataInput',
      name: 'Blood Pressure 1 - Sys',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'TextDataInput',
      name: 'Blood Pressure 1 - Dia',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Blood Pressure 1 - Arm',
      otherProps: {
        values: ['Left', 'Right'],
      },
    },
    {
      component: 'PlaceHolder',
      name: '',
    },
    {
      component: 'TextDataInput',
      name: 'Blood Pressure 2 - Sys',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'TextDataInput',
      name: 'Blood Pressure 2 - Dia',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Blood Pressure 2 - Arm',
      otherProps: {
        values: ['Left', 'Right'],
      },
    },
    {
      component: 'PlaceHolder',
      name: '',
    },
    {
      component: 'TextDataInput',
      name: 'Blood Pressure 3 - Sys',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'TextDataInput',
      name: 'Blood Pressure 3 - Dia',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Blood Pressure 3 - Arm',
      otherProps: {
        values: ['Left', 'Right'],
      },
    },
    {
      component: 'PlaceHolder',
      name: '',
    },
    {
      component: 'TextDataInput',
      name: 'Oxygen Saturation %',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'TextDataInput',
      name: 'Pulse (Resting heart rate)',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Pulse Rhythm',
      otherProps: {
        values: ['Regular', 'Irregular'],
      },
    },
    {
      component: 'TextDataInput',
      name: 'Respitory Rate',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'TextDataInput',
      name: 'HBA1C',
      otherProps: {
        inputType: 'number',
        required: true,
      },
    },
    {
      component: 'TextDataInput',
      name: 'Total Cholesterol',
      otherProps: {
        inputType: 'number',
        required: true,
      },
    },
    {
      component: 'TextDataInput',
      name: 'Triglycerides',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'TextDataInput',
      name: 'HDL',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'TextDataInput',
      name: 'LDL',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'TextDataInput',
      name: 'Temperature (°C)',
      otherProps: {
        inputType: 'number',
      },
    },
    {
      component: 'SelectDataInput',
      name: 'Lung Sounds (any wheeze, reduced air entry)',
      otherProps: {
        values: ['Normal', 'Wheeze', 'Crackle', 'Reduced air entry'],
      },
    },
    {
      component: 'TextDataInput',
      name: 'Peak Flow (if applicable)',
      otherProps: {
        inputType: 'number',
      },
    },
  ],
  Assessment: [
    {
      component: 'TextAreaDataInput',
      name: 'Overall Assessment',
    },
  ],
  Plan: [
    {
      component: 'PlanRecommendationInput',
      name: 'Recommendation',
    },
    {
      component: 'PlaceHolder',
      name: '',
    },
    {
      component: 'TextAreaDataInput',
      name: 'Clinical Notes',
    },
  ],
}
